if (!customElements.get("swat-sfl-list")) {
  class ComponentSwatSflList extends HTMLElement {
    constructor() {
      super();
      this.swatListId = null;
      this.swatInit();
    }
    swatInit() {
      let that = this;
      document.addEventListener("swymFinallyLoad", function () {
        window._swat.SaveForLater.init(
          (response) => {
            that.swatListId = response.listid;
            that.loadProducts();
          },
          (error) => {
            console.log("SWAT error: ", error);
          }
        );
      });
    }
    loadProducts() {
      window._swat.SaveForLater.fetch(
        this.swatListId,
        (response) => {
          console.log("response lid", response);
          if (response.items && response.items.length) {
            this.renderProducts(response.items, response.list.lid);
            this.style.display = null;
          } else {
            this.style.display = "none !important";
          }
        },
        (error) => {
          console.log("error", error);
        }
      );
    }
    renderProducts(products, listId) {
      this.querySelector(".keen-slider").innerHTML = products
        .map((product) => {
          return `
                <div class="keen-slider-slide">
                    <div class="product-card-wrapper">
                        <div class="image-container">
                            <div class="image">
                                <img class="img main lazyload" src="${
                                  product.iu
                                }" alt="${product.dt}">
                            </div>
                        </div>
                        <div class="info">
                            <div class="title">${product.dt}</div>
                            <div class="description">${product.vi}</div>
                            <div class="price">
                                <span class="final">$${product.pr}</span>
                            </div>
                        </div>
                        <div class="btn-wrap">
                            <button 
                                data-list-id="${listId}"
                                data-product-id="${product.empi}"
                                data-variant-id="${product.epi}"
                                data-du="${product.du}"
                                data-qty="${product.qty}"
                                data-cprops="${Object.keys(product.cprops)
                                  .map(
                                    (cprop) =>
                                      `${cprop}:${product.cprops[cprop]}`
                                  )
                                  .join(",")}"
                                class="btn-add-to-cart-sfl" 
                                aria-label="add-to-cart">Add to cart</button>
                        </div>
                    </div>
                </div>
            `;
        })
        .join("");

      this.initButtons();
      setTimeout(() => this.initSlider(), 250);
    }
    initButtons() {
      var that = this;
      Array.from(this.querySelectorAll(".btn-add-to-cart-sfl")).forEach(
        (elButton) => {
          elButton.addEventListener("click", (event) => {
            event.preventDefault();

            var variantId = event.currentTarget.dataset.variantId;
            var productId = event.currentTarget.dataset.productId;
            var qty = event.currentTarget.dataset.qty;
            var du = event.currentTarget.dataset.du;
            var listId = event.currentTarget.dataset.listId;

            var properties = {};
            event.currentTarget.dataset.cprops
              .split(",")
              .forEach(
                (prop) => (properties[prop.split(":")[0]] = prop.split(":")[1])
              );
            $s.post({
              url: "/cart/add.js",
              data: {
                id: variantId,
                qty: parseInt(qty),
                properties,
              },
              success: function () {
                console.log("added");
                window._swat.SaveForLater.remove(
                  listId,
                  [
                    {
                      du: du,
                      empi: productId,
                      epi: variantId,
                    },
                  ],
                  (response) => {
                    console.log("removed", response);
                    /*
                    that.restart();
                    window.CartPage.updateCart();
                    */
                    setTimeout(() => {
                      window.location.reload();
                    }, 500);
                  },
                  (error) => {
                    console.log("error", error);
                  }
                );
              },
              error: function (response) {
                console.log("error", response);
              },
            });
          });
        }
      );
    }
    restart() {
      if (this.sliderObj) this.sliderObj.destroy();
      this.querySelector(".keen-slider").innerHTML = "";
      this.loadProducts();
    }
    initSlider() {
      this.sliderObj = new KeenSlider(this.querySelector(".keen-slider"), {
        mode: "free-snap",
        loop: false,
        prevButton: this.querySelector(".keen-arrow-prev"),
        nextButton: this.querySelector(".keen-arrow-next"),
        autoplay: false,
        spacing: 15,
        breakpoints: {
          "(min-width: 901px)": {
            centered: false,
            slidesPerView: 3,
          },
          "(min-width: 601px) and (max-width: 900px)":
            {
              centered: false,
              slidesPerView: 3,
            },
          "(max-width: 600px)": {
            centered: false,
            slidesPerView: 2,
          },
        },
      });
    }
  }
  customElements.define("swat-sfl-list", ComponentSwatSflList);
}
